import { get, post, patch } from 'api/request'

export const API_CONTACT = "/contact/service/contact"
export const API_COMPANY_CONTACT = "/contact/service/company-contact"
export const API_ACTIVITY = "/contact/service/activity"
export const API_USER = "/directory/service/user"

export const getContactFields = (fieldName) => get(`${API_CONTACT}/contact_fields/${fieldName ? `?fields=${fieldName}` : ''}`)
export const getContactFilters = () => get(`${API_CONTACT}/counts`)
export const getContactList = (listKey, offset = 0, size = 20, filters = {}, order) => {
  let params = { offset, size }
  Object.keys(filters).forEach(k => {
    params[k] = filters[k]
  })
  if (order)
    params["order"] = order
  return get(`${API_CONTACT}?group=${listKey}`, { urlParams: params })
}
export const getContactDetail = (key, filter = {}) => get(`${API_CONTACT}/${key}`, { urlParams: filter })
export const getContactActivities = (offset = 0, size = 20, filters = {}, contact, group) => {
  let params = { offset, size, contact, group }
  Object.keys(filters).forEach(k => {
    params[k] = filters[k]
  })
  return get(API_ACTIVITY, { urlParams: params })
}
export const getContactAppEvents = (key) => get(`${API_CONTACT}/${key}/visit_history`)
export const addCompanyContact = (data) => post(`${API_COMPANY_CONTACT}/`, data)
export const getCompanyContact = (filters = {}) => get(`${API_COMPANY_CONTACT}/`, { urlParams: { sort_by: 'contact_name', ...filters } })
export const updateContact = (key, data) => patch(`${API_CONTACT}/${key}?fields=company_contacts`, data)
export const createContact = (data) => post(`${API_CONTACT}/?raise_duplicate_contact=1`, data)
export const linkContact = (contactKey, uid) => post(`${API_CONTACT}/${contactKey}/link_to_contact/`, { uid })
export const deleteCompanyContact = (contactKey, data) => patch(`${API_CONTACT}/${contactKey}`, data)
export const addNewOption = (fieldName, option) => post(`${API_CONTACT}/contact_field_options/?field=${fieldName}`, option)
export const addRecordActivity = (option) => post(`${API_CONTACT}/record_activity`, option)
export const editRecordActivity = (key, option) => patch(`${API_ACTIVITY}/${key}/`, option)
export const uploadMediaActivity = (media, onUploadProgress = null) => {
  let formData = new FormData()
  formData.append('media', media)

  return post(`${API_ACTIVITY}/upload_media`, formData, { timeout: 600000, onUploadProgress })
}
export const uploadMediaContact = (media, onUploadProgress = null) => {
  let formData = new FormData()
  formData.append('media', media)

  return post(`${API_CONTACT}/upload_media`, formData, { timeout: 600000, onUploadProgress })
}
export const getActivityType = (params = {}) => get(
  `${API_ACTIVITY}/activity_type/`, 
  { urlParams: params })

export const getUsers = () => get(`${API_USER}/staffs/`)